const parseDataForSearch = (data, metricSearch = true) => {
  const values = {
    query: [],
    demographics: [],
    responses: [],
    threshold: {},
    metrics: []
  }
  const parseRangeData = (lowerValue, higherValue, field, dataObj) => {
    if (lowerValue.value || higherValue.value) {
      const parsedRange = {
        field: field,
        filter: {
          type: 'range',
          from: lowerValue.value,
          to: higherValue.value
        },
        target: lowerValue.target
      }
      dataObj.push(parsedRange)
    }
  }
  const parseEqualData = (query, dataObj, excludedTags) => {
    Object.keys(query).forEach(tagKey => {
      if (!excludedTags.includes(tagKey) && query[tagKey].value) {
        if (
          (Array.isArray(query[tagKey].value) && query[tagKey].value.length) ||
          (typeof query[tagKey].value === 'string' && query[tagKey].value.length)
        ) {
          dataObj.push({
            field: query[tagKey].key,
            filter: {
              type: 'equal',
              value: query[tagKey].value
            },
            target: query[tagKey].target
          })
        } else if (typeof query[tagKey].value === 'object' && Object.keys(query[tagKey].value).length) {
          dataObj.push(query[tagKey].value)
        }
      }
    })
  }
  // parse search query
  const { startYear, endYear } = data.essentials
  if (startYear.value || endYear.value) {
    const year = {
      field: 'year',
      value: startYear.value,
      value_secondary: endYear.value,
      target: startYear.target
    }
    values.query.push(year)
  }

  const { creative } = data.fragranceDetails
  if (creative.value !== undefined) {
    values.query.push({
      field: 'bench_create',
      target: creative.target,
      value: creative.value ? ['Creative'] : ['Benchmark']
    })
  }

  const searchQuery = { ...data }
  delete searchQuery.metrics
  delete searchQuery.demographics
  Object.keys(searchQuery).forEach(searchKey => {
    const searchCategory = searchQuery[searchKey]
    Object.keys(searchCategory).forEach(tagKey => {
      if (
        (!['startYear', 'endYear'].includes(tagKey) && searchCategory[tagKey].value && searchCategory[tagKey].value.length
        ) || (tagKey === 'verified')
      ) {
        const tagValue = searchCategory[tagKey].value
        if (tagKey === 'region') {
          const index = tagValue.indexOf('APAC')
          if (index !== -1) tagValue.splice(index, 1)
        }
        values.query.push({
          field: searchCategory[tagKey].key,
          value: tagValue,
          target: searchCategory[tagKey].target
        })
      }
    })
  })

  // parse demographics query
  const demographicsQuery = { ...data.demographics }
  parseRangeData(demographicsQuery.startAge, demographicsQuery.endAge, 'age', values.demographics)
  parseEqualData(demographicsQuery, values.demographics, ['startAge', 'endAge'])

  // parse metrics, threshold and responses queries
  const metricsQuery = { ...data.metrics }
  Object.keys(metricsQuery).forEach(tagKey => {
    switch (tagKey) {
      case 'order':
        if (metricsQuery.order.value) {
          values.responses.push({
            field: metricsQuery.order.key,
            filter: metricsQuery.order.value === 'First'
              ? { type: 'equal', value: '1' }
              : {
                type: 'range',
                from: 2,
                to: 100
              }
          })
        }
        break
      case 'stage':
        if (metricsQuery[tagKey].value) {
          values.responses.push({
            field: metricsQuery[tagKey].key,
            filter: {
              type: 'equal',
              value: metricsQuery[tagKey].value
            }
          })
        }
        break
      case 'useConcepts':
        if (metricsQuery[tagKey]) {
          values.responses.push({
            field: 'concepts',
            filter: {
              type: 'equal',
              value: metricsQuery[tagKey]
            }
          })
          values.type = 'concept'
        }
        break
      case 'rdfType':
        if (metricsQuery[tagKey]) {
          values.responses.push({
            field: 'rdf_type',
            filter: {
              type: 'equal',
              value: metricsQuery[tagKey]['value']
            }
          })
        }
        break
      case 'threshold':
        if (metricsQuery[tagKey].applyThreshold) {
          values.threshold = {
            type: metricsQuery[tagKey].type,
            descending: metricsQuery[tagKey].desc,
            value: metricsQuery[tagKey].amount
          }
        }
        break
      default:
        const metricsList = metricsQuery[tagKey]
        metricsList.forEach(el => {
          if (el.metric.value && el.aggregation.value
          // && el.metricType.value
          ) {
            values.metrics.push({
              // type: el.metricType.value.toLowerCase(),
              field: el.metric.value,
              aggregation: el.aggregation.value,
              confidence: el.confidence.value
            })
          }
        })
    }
  })
  if (!data.metrics.threshold.applyThreshold) {
    delete values['threshold']
  }
  return metricSearch ? values : values.query
}

export default {
  parseDataForSearch
}
